import { render, staticRenderFns } from "./passwordForm.vue?vue&type=template&id=5ef86ad6"
import script from "./passwordForm.vue?vue&type=script&lang=js"
export * from "./passwordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports